import { render } from "./About.vue?vue&type=template&id=db957e06"
const script = {}
script.render = render

export default script